import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { api_routes } from '@app/consts';
import { EnvironmentService } from "@app/core/services/environment.service";
import { EmployeeProjectSubmit, EmployeeProjectVerbose } from '../models/employee-projects.model';


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EmployeeProjectsService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getEmployeeProjects(employeeId: string, take?: number, skip?: number, sort?: string): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;
    sort ? params = params.append('sort', sort) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROJECTS}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deleteEmployeeProject(employeeId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROJECTS}/${id}`, {
      headers: headers
    });
  }

  getEmployeeProject(employeeId: string, id: string): Observable<EmployeeProjectVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROJECTS}/${id}`, {
      headers: headers
    });
  }

  updateEmployeeProject(employeeId: string, employeeEmployeeProject: EmployeeProjectSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROJECTS}/${employeeEmployeeProject.id}`, employeeEmployeeProject, {
      headers: headers
    });
  }

  createEmployeeProject(employeeId: string, employeeEmployeeProject: EmployeeProjectSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.PROJECTS}`, employeeEmployeeProject, {
      headers: headers
    });
  }
}
